import React, { useEffect, useState, useCallback } from "react";
import LayoutV2 from "containers/LayoutV2";
import QuyTienMatSearch from "./QuyTienMatSearch";
import QuyTienMatTable from "./QuyTienMatTable";
import DongTienApi from "service/BaoCao/DongTienApi";
import TraGopApi from "service/traGopApi";
import { formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import { Modal } from "react-bootstrap";
import QuyTienMatDetailTable from "./QuyTienMatDetailTable";
import ChiTietDongLaiTatToanPhiKhac from "./ChiTietDongLaiTatToanPhiKhac";
import BtnInChiTiet from "./BtnInChiTiet";
import UserApi from "service/userApi";

const QuyTienMat = () => {
  const [dataSearch, setDataSearch] = useState({
    DateFrom: null,
    DateTo: null,
    hinhThucThanhToan: "-1",
  });

  const [reportData, setReportData] = useState({
    ListBaoCao: [],
    DuDauKy: 0,
    TonCuoiKy: 0,
  });
  const [showModal, setShowModal] = useState(false);
  const [detailData, setDetailData] = useState({
    List: [],
    TotalSoTien: 0,
    TotalPhiHoaHong: 0,
    TotalRecords: 0,
  });
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailInfo, setDetailInfo] = useState({
    category: "",
    flow: "",
    title: "",
  });
  const [detailPageIndex, setDetailPageIndex] = useState(1);
  const detailPageSize = 20;
  const [showSubModal, setShowSubModal] = useState(false);
  const [subDetailData, setSubDetailData] = useState({});
  const [subLoading, setSubLoading] = useState(false);
  const [subTitle, setSubTitle] = useState("");
  const [systemConfig, setSystemConfig] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasPermission, setHasPermission] = useState(null);
  const [RoleQuyTienMatChuyenQuy, setRoleQuyTienMatChuyenQuy] = useState(false);
  const [RoleQuyTienMatNhapQuy, setQuyTienMatNhapQuy] = useState(false);
  const [RoleQuyTienMatIn, setQuyTienMatIn] = useState(false);
  const [RoleQuyTienMatRutQuy, setQuyTienMatRutQuy] = useState(false);
  const [RoleQuyTienMatXuatExcel, setQuyTienMatXuatExcel] = useState(false);
  const [RoleQuyTienMatDuyetQuy, setQuyTienMatDuyetQuy] = useState(false);
  const fetchPermission = () => {
    setLoading(true);
    try {
      UserApi.getAllQuyen()
        .then((res) => {
          const detailedRoles = res.data.map((item) =>
            item.ModuleCode.toLowerCase()
          );
          const hasList = detailedRoles.includes("quytienmat");
          setHasPermission(hasList);
          if (hasList) {
            setRoleQuyTienMatChuyenQuy(
              detailedRoles.includes("quytienmat_chuyenquy")
            );
            setQuyTienMatNhapQuy(
              detailedRoles.includes("quytienmat_nhapquy")
            );
            setQuyTienMatIn(
              detailedRoles.includes("quytienmat_indanhsachquytienmat")
            );
            setQuyTienMatRutQuy(
              detailedRoles.includes("quytienmat_rutquy")
            );
            setQuyTienMatXuatExcel(
              detailedRoles.includes(
                "quytienmat_xuatdanhsachexcelquytienmat"
              )
            );
            setQuyTienMatDuyetQuy(
              detailedRoles.includes(
                "giaodichchoduyet_khongsudungduyetquy"
              )
            );
          }
        })
        .catch((err) => {
          console.error("Lỗi load quyền chi tiết:", err);
          setHasPermission(false);
        });
    } catch (err) {
      console.error("Lỗi fetchPermission:", err);
      setHasPermission(false);
    }
  };

  const fetchConfig = () => {
    TraGopApi.getConfigSys()
      .then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          const configObj = {};
          res.data.forEach((item) => {
            if (item.keyConfig) {
              configObj[item.keyConfig] = item.valueConfig;
            }
          });

          setSystemConfig(configObj);
        }
      })
      .catch((err) => {
        console.error("Lỗi lấy cấu hình hệ thống:", err);
      });
  };

  const loadData = useCallback(() => {
    setLoading(true);
    console.log("dataSearchdataSearchdataSearch", dataSearch);
    const DateFrom = dataSearch.DateFrom
      ? formatDayMonth(dataSearch.DateFrom)
      : "";
    const DateTo = dataSearch.DateTo ? formatDayMonth(dataSearch.DateTo) : "";
    const hinhThucThanhToan = dataSearch.hinhThucThanhToan ?? "-1";
    DongTienApi.getBaoCao(DateFrom, DateTo, hinhThucThanhToan)
      .then((res) => {
        if (res.status === 200) {
          setReportData(res.data);
        } else {
          pushNotification("Lấy dữ liệu thất bại", "error");
        }
      })
      .catch((err) => {
        pushNotification("Có lỗi xảy ra", "error");
      })
      .finally(() => setLoading(false));
  }, [dataSearch]);

  useEffect(() => {
    document.title = "Quỹ tiền mặt | Phần mềm quản lý cầm đồ";
    fetchConfig();
    fetchPermission();
  }, []);

  useEffect(() => {
    if (hasPermission) {
      loadData();
    }
  }, [hasPermission]);
  const handleSearch = () => {
    loadData();
  };

  const handleChangeDate = (field) => (date) => {
    setDataSearch((prev) => ({ ...prev, [field]: date }));
  };
  const handleChange = (field) => (e) => {
    const value = e.target.value;
    console.log("handleChange", value);
    setDataSearch((prev) => ({ ...prev, [field]: value }));
  };

  const mapCategoryToCode = (name) => {
    switch (name) {
      case "Cầm đồ":
        return "CAMDO";
      case "Tín chấp":
        return "TINCHAP";
      case "Trả góp":
        return "TRAGOP";
      case "Bán hàng trả góp":
        return "BHTG";
      case "Huy động vốn":
        return "HUYDONG";
      case "Nguồn vốn":
        return "NGUONVON";
      case "Quỹ khác":
        return "QUYKHAC";
      case "Rút quỹ":
        return "RUTQUY";
      case "Thu/Chi ngoài lề":
        return "NGOAILE";
      case "Trích lập dự phòng":
        return "TRICHLAP";
      default:
        return "";
    }
  };

  const fetchDetailData = (category, flow, page) => {
    setDetailLoading(true);
    const dateFrom = dataSearch.DateFrom
      ? formatDayMonth(dataSearch.DateFrom)
      : "";
    const dateTo = dataSearch.DateTo ? formatDayMonth(dataSearch.DateTo) : "";
    const hinhThucThanhToan = dataSearch.hinhThucThanhToan
      ? dataSearch.hinhThucThanhToan
      : "-1";
    DongTienApi.getChiTiet(
      category,
      flow,
      dateFrom,
      dateTo,
      page,
      detailPageSize,
      hinhThucThanhToan
    )
      .then((res) => {
        if (res.status === 200) {
          setDetailData(res.data);
        } else {
          pushNotification("Lỗi lấy dữ liệu", "error");
        }
      })
      .catch((err) => {
        console.error(err);
        pushNotification("Lỗi kết nối", "error");
      })
      .finally(() => {
        setDetailLoading(false);
      });
  };

  const handleDetailClick = (categoryName, flowType) => {
    const categoryCode = mapCategoryToCode(categoryName);
    if (!categoryCode) return;
    setDetailInfo({
      category: categoryCode,
      flow: flowType,
      title: `${categoryName} - ${flowType === "THU" ? "Thu" : "Chi"}`,
    });
    setDetailPageIndex(1);
    setShowModal(true);
    fetchDetailData(categoryCode, flowType, 1);
  };

  const handleDetailPageChange = (pageNumber) => {
    setDetailPageIndex(pageNumber);
    fetchDetailData(detailInfo.category, detailInfo.flow, pageNumber);
  };
  const handleMoneyClick = (thuChiId, loaiGiaoDich) => {
    setShowModal(false);
    setSubTitle(`Chi tiết ${loaiGiaoDich}`);
    setShowSubModal(true);
    setSubLoading(true);
    setSubDetailData({});
    DongTienApi.getChiTietGiaoDich(thuChiId)
      .then((res) => {
        if (res.status === 200) setSubDetailData(res.data);
      })
      .catch(() => pushNotification("Lỗi tải chi tiết", "error"))
      .finally(() => setSubLoading(false));
  };

  const handleCloseSubModal = () => {
    setShowSubModal(false);
    setShowModal(true);
  };

  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }
  return (
    <LayoutV2>
      <div className="col-12">
        <div className="camdo-home">
          <div className="breadcrumb-new ">
            <div className="row">
              <div
                className="col-md-12 mb-1 mt-1 header"
                style={{ justifyContent: "flex-start" }}
              >
                <img
                  src="/app-assets/images/icon-thong-ke.png"
                  alt="Mẫu hợp đồng"
                />
                <h1
                  className="text-info-home"
                  style={{ margin: 0, marginLeft: 10 }}
                >
                  Báo cáo - Dòng tiền
                </h1>
              </div>
            </div>
          </div>
          <QuyTienMatSearch
            dataSearch={dataSearch}
            onChangeDate={handleChangeDate}
            onSearch={handleSearch}
            handleChange={handleChange}
          />
          <QuyTienMatTable
            loading={loading}
            data={reportData.ListBaoCao}
            dauKy={reportData.DuDauKy}
            cuoiKy={reportData.TonCuoiKy}
            dateFrom={dataSearch.DateFrom}
            dateTo={dataSearch.DateTo}
            onDetailClick={handleDetailClick}
            config={systemConfig}
            onReload={loadData}
            RoleQuyTienMatChuyenQuy={RoleQuyTienMatChuyenQuy}
            RoleQuyTienMatNhapQuy={RoleQuyTienMatNhapQuy}
            RoleQuyTienMatIn={RoleQuyTienMatIn}
            RoleQuyTienMatRutQuy={RoleQuyTienMatRutQuy}
            RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
          />
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          dialogClassName="modal-90w"
          centered
          className="modal-new modal-fade"
          style={{ zIndex: 1050 }}
        >
          <div className="modal-content">
            <div className="modal-header ">
              <h4 className="modal-title color7-bold ml-1 mt-1">
                {detailInfo.title}
              </h4>
              <button
                type="button"
                className="close-popup-new"
                onClick={() => setShowModal(false)}
              >
                <i className="mdi mdi-close"></i>
              </button>
            </div>

            <div className="modal-body p-1">
              <QuyTienMatDetailTable
                data={detailData.List}
                totalMoney={detailData.TotalSoTien}
                totalCommission={detailData.TotalPhiHoaHong}
                totalRecords={detailData.TotalRecords}
                pageIndex={detailPageIndex}
                pageSize={detailPageSize}
                onPageChange={handleDetailPageChange}
                loading={detailLoading}
                config={systemConfig}
                category={detailInfo.category}
                flow={detailInfo.flow}
                onMoneyClick={handleMoneyClick}
              />
            </div>

            <div className="modal-footer">
              {RoleQuyTienMatIn && (
                <BtnInChiTiet
                  category={detailInfo.category}
                  flow={detailInfo.flow}
                  dateFrom={dataSearch.DateFrom}
                  dateTo={dataSearch.DateTo}
                  title={detailInfo.title}
                  config={systemConfig}
                />
              )}
              <button
                className="btn btn-new-main btn-closenew"
                onClick={() => setShowModal(false)}
              >
                <i className="fas fa-times"></i> Đóng
              </button>
            </div>
          </div>
        </Modal>
        <ChiTietDongLaiTatToanPhiKhac
          show={showSubModal}
          onHide={handleCloseSubModal}
          data={subDetailData}
          loading={subLoading}
          title={subTitle}
        />
      </div>
    </LayoutV2>
  );
};

export default QuyTienMat;
